/**
 * Cultiv — Areas of Cultivation.
 *
 * ONE GARDEN. Eight interconnected areas.
 * Every user's life is a single, connected garden. The eight areas below
 * are facets of that one garden — never presented as separate plots.
 *
 * Each area carries: virtue verbs (from the vision board), a mentor phrase,
 * a lucide icon, an accent color (all within the Cultiv palette), and an
 * editorial photograph curated by the design pass. Photography is muted,
 * organic, film-toned — never stock/model-facing.
 */
import { Heart, Sprout, Brain, Home as HomeIcon, Users, Briefcase, Sun, Crown } from "lucide-react";

export const AREAS = [
    {
        key: "heart",
        label: "Heart",
        virtue: "Draw near. Abide.",
        subtitle: "Relationship with God, prayer, scripture, identity, emotional health.",
        Icon: Heart,
        accent: "hsl(var(--eden-forest))",
        image: "https://images.unsplash.com/photo-1490645935967-10de6ba17061?w=1400&auto=format&fit=crop&q=80",
    },
    {
        key: "body",
        label: "Body",
        virtue: "Care well. Fuel well.",
        subtitle: "Movement, nutrition, sleep, stress, vitality.",
        Icon: Sprout,
        accent: "hsl(var(--eden-olive))",
        image: "https://images.unsplash.com/photo-1519996529931-28324d5a630e?w=1400&auto=format&fit=crop&q=80",
    },
    {
        key: "mind",
        label: "Mind",
        virtue: "Renew thoughts. Focus well.",
        subtitle: "Thought life, learning, focus, creativity.",
        Icon: Brain,
        accent: "hsl(var(--eden-sage))",
        image: "https://images.unsplash.com/photo-1481627834876-b7833e8f5570?w=1400&auto=format&fit=crop&q=80",
    },
    {
        key: "home",
        label: "Home",
        virtue: "Create peace. Cultivate beauty.",
        subtitle: "Peace, organization, stewardship, hospitality.",
        Icon: HomeIcon,
        accent: "hsl(var(--eden-taupe))",
        image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1400&auto=format&fit=crop&q=80",
    },
    {
        key: "relationships",
        label: "Relationships",
        virtue: "Love well. Forgive well.",
        subtitle: "Marriage, children, friendships, church, forgiveness.",
        Icon: Users,
        accent: "hsl(var(--eden-gold))",
        image: "https://images.unsplash.com/photo-1543269664-56d93c1b41a6?w=1400&auto=format&fit=crop&q=80",
    },
    {
        key: "work",
        label: "Work & Calling",
        virtue: "Serve with purpose. Steward well.",
        subtitle: "Purpose, career, time & financial stewardship, using your gifts.",
        Icon: Briefcase,
        accent: "hsl(var(--eden-olive))",
        image: "https://images.unsplash.com/photo-1497366216548-37526070297c?w=1400&auto=format&fit=crop&q=80",
    },
    {
        key: "rest",
        label: "Rest",
        virtue: "Receive rest. Enjoy well.",
        subtitle: "Sabbath, margin, joy, contentment.",
        Icon: Sun,
        accent: "hsl(var(--eden-gold))",
        image: "https://images.unsplash.com/photo-1493246507139-91e8fad9978e?w=1400&auto=format&fit=crop&q=80",
    },
    {
        key: "kingdom",
        label: "Kingdom",
        virtue: "Give well. Impact well.",
        subtitle: "Service, generosity, discipleship, obedience.",
        Icon: Crown,
        accent: "hsl(var(--eden-forest))",
        image: "https://images.unsplash.com/photo-1439853949127-fa647821eba0?w=1400&auto=format&fit=crop&q=80",
    },
];

// Back-compat aliases — many pages still import GARDENS/gardenByKey/gardenByLabel.
export const GARDENS = AREAS;
export const areaByKey = (key) => AREAS.find((g) => g.key === key);
export const areaByLabel = (label) => AREAS.find((g) => g.label === label);
export const gardenByKey = areaByKey;
export const gardenByLabel = areaByLabel;
